import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { TemplateWrapperComponent } from './template-wrapper/template-wrapper.component';
import { PagesModule } from '../pages/pages.module';

@NgModule({
  declarations: [HeaderComponent, SidebarComponent, TemplateWrapperComponent],
  imports: [RouterModule,CommonModule],
  exports: [TemplateWrapperComponent, HeaderComponent, SidebarComponent]
})
export class LayoutModule {}
